import {ServerHolder} from "./components/groups-admin";
import {ThunkDispatch} from "redux-thunk";
import {AnyAction} from "redux";
import GroupAdminState from "./GroupAdminState";

export enum AdminActionType {
    FETCH_CONTRACT_GROUPS,
    SET_SELECTED_CONTRACTGROUP,
    SET_USER,
    HIGHLIGHT_USER,
    IS_LOADING,
}

export type GroupAdminThunk = (dispatch: ThunkDispatch<GroupAdminState, ServerHolder, AnyAction>,
                               getState: () => GroupAdminState,
                               serverHolder: ServerHolder) => void

export type ShowErrorMessage = (message: string) => GroupAdminThunk;
export const showErrorMessage: ShowErrorMessage = (message) => (dispatch, getState, serverHolder) => {
    serverHolder.server.messages.danger(message);
    serverHolder.scope.$digest();
};


export type InitGroupAdmin = () => GroupAdminThunk;
export const initGroupAdmin: InitGroupAdmin = () => (dispatch, getState, serverHolder) => {
    serverHolder.security.ensureCurrentUser()
        .then(user => {
            dispatch({
                type: AdminActionType.SET_USER,
                user: user
            });
            dispatch(getContractGroups());
        });
};

export type RemoveContractFromGroup = (contractId: string, groupId: string) => GroupAdminThunk;
export const removeContractFromGroup: RemoveContractFromGroup = (contractId, groupId) => async (dispatch, getState, serverHolder) => {

    let removeContractParams = {
        contractid: contractId
    };

    let result = await serverHolder.fetch.post(`/rest/contractgroup/${groupId}/removecontract`, removeContractParams);
    if (result.success) {
        dispatch(getContractGroups());
    } else {
        if (result.message) {
            dispatch(showErrorMessage(result.message))
        } else {
            dispatch(showErrorMessage("Klarte ikke å slette kontrakten fra kontrakatgruppen"));
        }
    }
};


export type AddUserToGroup = (username: string, groupId: string) => GroupAdminThunk;
export const addUserToGroup: AddUserToGroup = (username, groupId) => async (dispatch, getState, serverHolder) => {
    let postData = {
        username: username,
    };

    let result = await serverHolder.fetch.post(`/rest/contractgroup/${groupId}/adduser`, postData);
    if (result.success) {
        dispatch(highlightUser(username));
        dispatch(getContractGroups());
    } else {
        if (result.message) {
            dispatch(showErrorMessage(result.message))
        } else {
            dispatch(showErrorMessage("Klarte ikke å legge til brukeren."));
        }

    }
};

export type HighlightUser = (highlightedUserName: string) => GroupAdminThunk;
export const highlightUser: HighlightUser = (highlightedUserName) => (dispatch) => {
    dispatch({
        type: AdminActionType.HIGHLIGHT_USER,
        highlightedUserName
    })
};

export type RemoveUserFromGroup = (username: string, groupId: string) => GroupAdminThunk;
export const removeUserFromGroup: RemoveUserFromGroup = (username, groupId) => async (dispatch, getState, serverHolder) => {

    let postData = {
        username: username
    };

    let result = await serverHolder.fetch.post(`/rest/contractgroup/${groupId}/removeuser`, postData);
    if (result.success) {
        dispatch(getContractGroups());
    } else {
        if (result.message) {
            dispatch(showErrorMessage(result.message))
        } else {
            dispatch(showErrorMessage("Klarte ikke å fjerne brukeren fra gruppen."));
        }
    }
};


export type GetContractGroups = () => GroupAdminThunk;
export const getContractGroups: GetContractGroups = () => async (dispatch, getState, serverHolder) => {
    let result = await serverHolder.fetch.get("/rest/contractgroup/list");

    if (result.success) {
        let contractGroups = result.data;
        dispatch({
            type: AdminActionType.FETCH_CONTRACT_GROUPS,
            contractGroups
        })

        dispatch({
            type: AdminActionType.IS_LOADING,
            isLoading: false,
        })
    }
};

export type SetUserRole = (role: string, username: string, contractGroupId: string) => GroupAdminThunk;
export const setUserRole: SetUserRole = (role, user, groupId) => async (dispatch, getState, serverHolder) => {
    let postData = {
        username: user,
        role: role
    };
    let result = await serverHolder.fetch.post(`/rest/contractgroup/${groupId}/setuserrole`, postData);
    if (result.success) {
        dispatch(getContractGroups());
    } else {
        if (result.message) {
            dispatch(showErrorMessage(result.message))
        } else {
            dispatch(showErrorMessage("Klarte ikke å endre brukerens rolle."));
        }
        dispatch(getContractGroups());
    }
};

export type SetSelectedContractGroup = (selectedContractGroupId: string) => GroupAdminThunk;
export const setSelectedContractGroup: SetSelectedContractGroup = (selectedContractGroupId) => (dispatch) => {
    dispatch(
        {
            type: AdminActionType.SET_SELECTED_CONTRACTGROUP,
            selectedContractGroupId
        }
    )
};

export type CreateContractGroup = (name: string) => GroupAdminThunk;
export const createContractGroup: CreateContractGroup = (groupname) => async (dispatch, getState, serverHolder) => {
    let result = await serverHolder.fetch.post("rest/contractgroup/addgroup", {groupname});

    if (result.success) {
        await dispatch(getContractGroups());
        await dispatch(setSelectedContractGroup(result.data.groupid));
    } else {
        if (result.message) {
            dispatch(showErrorMessage(result.message))
        } else {
            dispatch(showErrorMessage("Klarte ikke å opprette ny kontraktgruppe"));
        }

    }
};

export type RenameContractGroup = (groupId: string, groupname: string) => GroupAdminThunk;
export const renameContractGroup: RenameContractGroup = (groupId, groupname) => async (dispatch, getState, serverHolder) => {
    let result = await serverHolder.fetch.post(`/rest/contractgroup/${groupId}/setgroupname`, {groupname})

    if (result.success) {
        await dispatch(getContractGroups());
    } else {
        if (result.message) {
            dispatch(showErrorMessage(result.message))
        } else {
            dispatch(showErrorMessage("Klarte ikke å endre navn på kontraktgruppa"))
        }
    }
}

export type DeleteContractGroup = (groupId: string) => GroupAdminThunk;
export const deleteContractGroup: DeleteContractGroup = (groupId) => async (dispatch, getState, serverHolder) => {
    let result = await serverHolder.fetch.post(`rest/contractgroup/${groupId}/removegroup`, {});

    if (result.success) {
        await dispatch(getContractGroups());
    } else {
        if (result.message) {
            dispatch(showErrorMessage(result.message))
        } else {
            dispatch(showErrorMessage("Klarte ikke å slette kontraktgruppa"))
        }
    }
}
